module.exports = __webpack_public_path__ + "static/media/Yelan.073932dc.png";